import React from "react";

//Components
import LoadingModal from "../CustomUIComponents/LoadingModal/LoadingModal";
import InvoiceApproval from "./InvoiceApproval";
import UserNotification from "../CustomUIComponents/UserNotification/UserNotification";

//Action
import { getInvoiceAction, approvedInvoiceAction } from "./Actions";

//Constants
import { OPERATION_STATUS } from "../../config/axios.init";

//Strings
import { Strings } from "../../resources/i18n/i18n";

//Utility
import Utility from "../../utils/Utility";

class InvoiceApprovalContainer extends React.Component {
  constructor(props) {
    super(props);
    /**
     * Below function call is used for restricting multiple API calls.
     * Passed API call and time in miliseconds to debounce function as arguments which ensures that the API call is made only once within a specified time frame, even if the button is clicked multiple times.
     */
    this.debounceHandleApprove = Utility.debounce(this.callHandleApprove, 10000);
    this.state = {
      invoiceList: [],
      numberOfPages: 0,
      showLoadingModal: false,
      successMessage: "",
      level: "",
      showToast: false,
    };
  }

  handleOnClickSearchFilter = (request) => {
    this.setState({ showLoadingModal: true });
    getInvoiceAction(request, (response) => {
      if (response.status === OPERATION_STATUS.SUCCESS) {
        this.setState({
          invoiceList: response.data.data.rp,
          numberOfPages: response.data.data.np,
          showLoadingModal: false,
        });
      } else {
        this.setState({
          invoiceList: [],
          numberOfPages: 0,
          showLoadingModal: false,
          errorMessage: response.error.message,
        });
      }
    });
  };

  callHandleApprove = (request, callback) => {
    this.setState({ showLoadingModal: true, showToast: false });
    approvedInvoiceAction(request, (response) => {
      if (response.status === OPERATION_STATUS.SUCCESS) {
        this.setState(
          {
            showToast: true,
            level: "success",
            successMessage: Strings("invoice" + request.st),
            showLoadingModal: false,
          },
          callback
        );
      } else {
        this.setState({
          showToast: true,
          level: "error",
          successMessage: response.error.message,
          showLoadingModal: false,
          errorMessage: response.error.message,
        });
      }
    });
  };

  handleApprove = (request, callback) => {
    this.debounceHandleApprove(request, callback);
  };


  render() {
    return (
      <div>
        <LoadingModal
          showLoadingModal={this.state.showLoadingModal}
        />
        {this.state.showToast && (
          <UserNotification
            key='Success'
            userNotificationObj={{
              message: Strings(this.state.successMessage),
              level: this.state.level,
            }}
          />
        )}
        <InvoiceApproval
          invoiceList={this.state.invoiceList}
          numberOfPages={this.state.numberOfPages}
          handleOnClickSearchFilter={this.handleOnClickSearchFilter}
          handleApprove={this.handleApprove}
        />
      </div>
    );
  }
}

export default InvoiceApprovalContainer;
